import { createSlice } from '@reduxjs/toolkit'
import { ApiState, ServerResponse } from "@baseTypes/baseType";
import { applyExtraReducer } from "../../../weather";
import { createThunk, DashboardReqBody } from "../../crops/selector";
import { DashboardQueryParams } from "@pages/dashboard/phases";
import { dashboardURL } from "@utils/utils";
import { ByDaysData } from "@baseTypes/service/dashboard/IExpensesDashboardService";
import urlcat from "urlcat";
import colors from "@infobis/ui-styles-utils/colors";

export interface ExpensesDetalizationData {
    title: string,
    byDays: ByDaysData,
    badgeBg: string,
    badgeFg: string,
    badgeStroke: string,
    chartBg: string,
    /**
     * @deprecated
     */
    color: string,
    /**
     * @deprecated
     */
    color2: string,
    totalFact: number
}

export interface ExpensesDetalizationState extends ApiState {
    data: ExpensesDetalizationData[]
}

const initialState: ExpensesDetalizationState = {
    data: [],
    apiError: undefined,
    isApiLoading: false
}
const expenseTransformer = async (response: ServerResponse<ExpensesDetalizationData[]>) => {
    return {
        ...response, data: response.data.map((el: ExpensesDetalizationData) => {
            if(el.title === "СЗР") {
                return {...el,
                    color: "#C3F7B1",
                    color2: "#36A064",
                    badgeBg: colors.BADGE_FILL_CHARTS_12,
                    badgeStroke: colors.BADGE_STROKE_CHARTS_12,
                    badgeFg: colors.TYPO_BADGE_GREEN,
                    chartBg: colors.ELEMENTS_CHARTS_12
                }
            }
            if(el.title === "Удобрения") {
                return {...el,
                    color: "#CCEAFF",
                    color2: "#438CEE",
                    badgeBg: colors.BADGE_FILL_CHARTS_6,
                    badgeStroke: colors.BADGE_STROKE_CHARTS_6,
                    badgeFg: colors.TYPO_BADGE_BLUE,
                    chartBg: colors.ELEMENTS_CHARTS_6
                }
            }
            if(el.title === "Семена") {
                return {...el,
                    color: "#FFCCCC",
                    color2: "#EB5757",
                    badgeBg: colors.BADGE_FILL_CHARTS_15,
                    badgeStroke: colors.BADGE_STROKE_CHARTS_15,
                    badgeFg: colors.TYPO_BADGE_YELLOW,
                    chartBg: colors.ELEMENTS_CHARTS_15
                }
            }
            return el
        })
    }
}

type ExpenesesDetalizationParams = DashboardQueryParams & { month: number }

const fetchExpensesDetalization = createThunk<ExpensesDetalizationData[], ExpenesesDetalizationParams, DashboardReqBody>()(
    { url: dashboardURL('detailsCosts'), transformer: expenseTransformer, method: "POST" },
    (payload, url) => ({
        url: urlcat(url, {month: payload.month, year: payload.year}),
        data: {
            cropRotationIds: payload.cropRotationIds || []
        }
    })
)

const expensesDetalizationSlice = createSlice({
    name: 'expensesDetalizationSlice',
    initialState,
    reducers: {
    },
    extraReducers: (builder) => {
        applyExtraReducer(builder, fetchExpensesDetalization)
    },
})

export const actions = { ...expensesDetalizationSlice.actions, fetchExpensesDetalization }
export default expensesDetalizationSlice.reducer